import { render, staticRenderFns } from "./ConfirmCart.vue?vue&type=template&id=5d3c413f&scoped=true"
import script from "./ConfirmCart.vue?vue&type=script&lang=ts"
export * from "./ConfirmCart.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmCart.vue?vue&type=style&index=0&id=5d3c413f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3c413f",
  null
  
)

export default component.exports